module.exports = __webpack_public_path__ + "static/media/minimize-arrows.d1b35b02.svg";